// voiceEntrySaga.ts
import { call, put, takeLatest } from "redux-saga/effects";
import { voiceEntryActionTypes } from "./voiceEntryTypes";
import { voiceEntryApiResponseSuccess, voiceEntryApiResponseError } from "./voiceEntryActions";
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { submitAudioEntryApi, updateAudioEntryApi } from "../../api/voiceEntry";
import { approvedEntrySubmitApi } from "../../api/voiceEntry";
import { z } from "zod";
import { GeminiBookingSchema, VoiceEntryResponseSchema } from "../../shared/schemas/api/voiceEntry.schema";



// function* submitAudioEntrySaga(action: any) {
//     try {
//       const file:File = action.payload;
//       console.log("submitAudioEntrySaga: Sending file to backend", file);
//       // Generate a blob URL from the file itself
//     // const audioUrl = URL.createObjectURL(file);
//       const response: Promise<any> = yield call(submitAudioEntryApi, action.payload);
//       console.log("Backend response from submitAudioEntryApi", response);
//       yield put(voiceEntryApiResponseSuccess(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, response));
//       showSuccessNotification(`🚀 Audio entry submitted successfully!`);

//     } catch (error: any) {
//       console.error("submitAudioEntrySaga: Error submitting audio entry", error.message);
//       yield put(voiceEntryApiResponseError(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, error.message));
//       showErrorNotification("Execution failed: " + error.message);
//     }
//   }

// BEGIN GENERATED SAGA FUNCTION
// END GENERATED SAGA FUNCTION



// function* submitAudioEntrySaga(action: any) {
//   try {
//     const { file, fileType } = action.payload;
//     console.log("submitAudioEntrySaga: Sending file and type to backend", file, fileType);

//     const response: Promise<any> = yield call(submitAudioEntryApi, { file, fileType });
//     console.log("Backend response from submitAudioEntryApi", response);

//     yield put(voiceEntryApiResponseSuccess(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, response));
//     yield put({
//       type: voiceEntryActionTypes.SET_PROCESSING_STATUS,
//       payload: "processed",
//     }); 
//     showSuccessNotification(`🚀 Audio entry submitted successfully!`);

//   } catch (error: any) {
//     console.error("submitAudioEntrySaga: Error submitting audio entry", error.message);
//     yield put(voiceEntryApiResponseError(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, error.message));
//      yield put({
//       type: voiceEntryActionTypes.SET_PROCESSING_STATUS,
//       payload: "idle",
//     });
//     showErrorNotification("Execution failed: " + error.message);
//   }
// }





function* submitAudioEntrySaga(action: any) {
  try {
    const { file, fileType } = action.payload;
    console.log("submitAudioEntrySaga: Sending file and type to backend", file, fileType);

    const response: Promise<any> = yield call(submitAudioEntryApi, { file, fileType });
    console.log("Backend response from submitAudioEntryApi", response);

    // ✅ Validate Zod output structure here
    const parsed = VoiceEntryResponseSchema.safeParse(response);

    if (!parsed.success) {
      console.error("❌ Zod validation failed in Saga", parsed.error.format());
      yield put(voiceEntryApiResponseError(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, "Invalid response structure"));
      yield put({ type: voiceEntryActionTypes.SET_PROCESSING_STATUS, payload: "idle" });
      showErrorNotification("Received invalid response format from backend.");
      return;
    }

    
    

    // ✅ Optional: Further validate just entryResult if needed
    const parsedEntry = GeminiBookingSchema.safeParse(parsed.data.entryResult);
    if (!parsedEntry.success) {
      console.error("❌ Zod validation failed for entryResult", parsedEntry.error.format());
      yield put(voiceEntryApiResponseError(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, "Invalid entryResult format"));
      yield put({ type: voiceEntryActionTypes.SET_PROCESSING_STATUS, payload: "idle" });
      showErrorNotification("Invalid format for entryResult.");
      return;
    }
    console.log("[submitAudioEntrySaga] zod validation success", parsedEntry.success);

    // ✅ Validated: Proceed to update state
    yield put(voiceEntryApiResponseSuccess(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, parsed.data));
    yield put({ type: voiceEntryActionTypes.SET_PROCESSING_STATUS, payload: "processed" });

    showSuccessNotification(`🚀 Audio entry submitted successfully!`);

  } catch (error: any) {
    console.error("submitAudioEntrySaga: Error submitting audio entry", error.message);
    yield put(voiceEntryApiResponseError(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, error.message));
    yield put({ type: voiceEntryActionTypes.SET_PROCESSING_STATUS, payload: "idle" });
    showErrorNotification("Execution failed: " + error.message);
  }
}



function* updateAudioEntrySaga(action: any) {
  try {
    const { file, fileType, previousEntryResult } = action.payload;
    console.log("submitAudioEntryManualEditSaga: Sending file and type to backend", file, fileType);

    const response: Promise<any> = yield call(updateAudioEntryApi, { file, fileType, previousEntryResult });
    console.log("Backend response from submitAudioEntryManualEditSaga", response);

    yield put(voiceEntryApiResponseSuccess(voiceEntryActionTypes.UPDATE_AUDIO_ENTRY, response));
    // yield put({
    //   type: voiceEntryActionTypes.SET_PROCESSING_STATUS,
    //   payload: "processed",
    // }); 
    showSuccessNotification(`🚀 Audio entry submitted successfully!`);

  } catch (error: any) {
    console.error("submitAudioEntryManualEditSaga: Error submitting audio entry", error.message);
    yield put(voiceEntryApiResponseError(voiceEntryActionTypes.UPDATE_AUDIO_ENTRY, error.message));
    //  yield put({
    //   type: voiceEntryActionTypes.SET_PROCESSING_STATUS,
    //   payload: "idle",
    // });
    showErrorNotification("Execution failed: " + error.message);
  }
}


function* approvedEntrySubmitSaga(action: any) {
  try {
    const data = action.payload;  // ✅ Corrected
    console.log("approvedEntrySubmitSaga action payload", data);

    if (!data) {
      console.error("Missing payload for approvedEntrySubmitSaga");
    }

    const response = yield call(approvedEntrySubmitApi, data);
    console.log("Backend response from approvedEntrySubmit API: ", response);

    if (response?.error) {
      console.log("[approvedEntrySubmitSaga] response.error condition triggered", response.error);
      yield put(voiceEntryApiResponseError(voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT, response.message));
      showErrorNotification("Failed to approvedEntrySubmit: " + response.message);
      return;
    }

    yield put(voiceEntryApiResponseSuccess(voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT, response));
    showSuccessNotification(`🚀 approvedEntrySubmit successfully!`);
    
  } catch (error: any) {
    console.error("Saga error while approvedEntrySubmit:", error.message);
    yield put(voiceEntryApiResponseError(voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT, error.message));
    showErrorNotification("Failed to approvedEntrySubmit: " + error.message);
  }
}



// Root saga to watch for the actions
export default function* voiceEntrySaga() {
  yield takeLatest(voiceEntryActionTypes.SUBMIT_AUDIO_ENTRY, submitAudioEntrySaga);
  yield takeLatest(voiceEntryActionTypes.UPDATE_AUDIO_ENTRY, updateAudioEntrySaga);
   yield takeLatest(voiceEntryActionTypes.APPROVED_ENTRY_SUBMIT, approvedEntrySubmitSaga);

}
